import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["quantity", "quantityField"]

  increment() {
    const quantitySpan = this.quantityTarget
    const quantityField = this.quantityFieldTarget
    
    if (quantitySpan && quantityField) {
      const currentValue = parseInt(quantitySpan.textContent) || 0
      const newValue = currentValue + 1
      
      quantitySpan.textContent = newValue
      quantityField.value = newValue
    }
  }

  decrement() {
    const quantitySpan = this.quantityTarget
    const quantityField = this.quantityFieldTarget
    
    if (quantitySpan && quantityField) {
      const currentValue = parseInt(quantitySpan.textContent) || 0
      const newValue = Math.max(0, currentValue - 1)
      
      quantitySpan.textContent = newValue
      quantityField.value = newValue
    }
  }
}
